import React from "react";
import { motion } from "framer-motion";
import { BiLogoInstagram } from "react-icons/bi";

interface InstagramLink {
  name: string;
  link: string;
  username: string;
}

export type { InstagramLink };

const instagramLinks: InstagramLink[] = [
  {
    name: "Bali",
    username: "@lokerbali.top",
    link: "https://instagram.com/lokerbali.top",
  },
  {
    name: "Denpasar",
    username: "@lokerdenpasar.top",
    link: "https://instagram.com/lokerdenpasar.top",
  },
  {
    name: "Badung",
    username: "@lokerbadung.top",
    link: "https://instagram.com/lokerbadung.top",
  },
  {
    name: "Gianyar",
    username: "@lokergianyar.top",
    link: "https://instagram.com/lokergianyar.top",
  },
  {
    name: "Tabanan",
    username: "@lokertabanan.top",
    link: "https://instagram.com/lokertabanan.top",
  },
  {
    name: "Karangasem",
    username: "@lokerkarangasem.top",
    link: "https://instagram.com/lokerkarangasem.top",
  },
  {
    name: "Buleleng",
    username: "@lokerbuleleng.top",
    link: "https://instagram.com/lokerbuleleng.top",
  },
  {
    name: "Jembrana",
    username: "@lokerjembrana.top",
    link: "https://instagram.com/lokerjembrana.top",
  },
];

export { instagramLinks };

const InstagramBali = () => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center">
      <div className="flex flex-col items-center justify-center w-full">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="px-4 py-8"
        >
          <img
            src="/images/instagram-logo.svg"
            alt="Instagram"
            className="w-20 h-20 sm:w-26 sm:h-26 md:w-28 md:h-28 lg:w-28 lg:h-28 rounded-full shadow-[0_0_15px_rgba(6,182,212,0.5)] hover:shadow-[0_0_20px_rgba(6,182,212,0.7)] transition-all duration-300 object-cover mx-auto mb-6"
          />
          <h2 className="text-center font-bold text-xl text-gray-300">
            Berikut Link Akun Instagram Provinsi Bali
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="w-full max-w-2xl grid grid-cols-1 md:grid-cols-2 gap-4 py-4 px-4 items-center justify-center"
        >
          {instagramLinks.map((account, index) => (
            <a
              key={index}
              href={account.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between p-4 bg-gray-800/80 backdrop-blur-sm rounded-xl hover:bg-gray-700 transition-all duration-300 group"
            >
              <BiLogoInstagram className="text-2xl text-cyan-500 group-hover:text-cyan-400 transition-colors duration-300" />
              <div className="flex flex-col items-center justify-center">
                <h3 className="text-gray-200 font-medium">{account.name}</h3>
                <p className="text-sm text-gray-400">{account.username}</p>
              </div>
              <BiLogoInstagram className="text-2xl text-cyan-500 group-hover:text-cyan-400 transition-colors duration-300" />
            </a>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default InstagramBali;
